import { controls,grouped } from "../controls";
const editor = {
label: "Oropages",
pageLabel: "Oropages",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Page Name%",description:'Starting partial search. e.g. You can search for Shivraj Deshmukh by typing shivraj.'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "page_name%",maxlength:30}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Module"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "module",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Submodule"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "submodule",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description",description:'Starting partial search. e.g. You can search for Shivraj Deshmukh by typing shivraj.'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "page_display%",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Page Name",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "page_name",isRequired:true,maxlength:30 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "page_display",isRequired:true,maxlength:50 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Module",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "module",isRequired:true,maxlength:50 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Submodule",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "submodule",maxlength:50 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Code",width:"col-sm-12"}),
...controls.simpleeditor({ tab: "general",name: "code"}),
...controls.displayText({ tab: "general", label: "Query Group",star:false}),
...controls.oc({ tab: "general", c: "QueryGroup", placeHolder: "Query Group Code", name: "query_group_code",fastpath: "query_groups",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "query_group_display"}),
]
,history:{
perPage: 10,
reportHeader: "Oropages",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Page Name",accessor: "page_name",},
{Header: "Page",accessor: "page_display",},
{Header: "Module",accessor: "module",},
{Header: "Submodule",accessor: "submodule",},
{Header: "Createdat",accessor: "createdat",type:'date'},
{Header: "Query Group Code",accessor: "OroPage-query_group-query_group_code",},
{Header: "Query Group",accessor: "OroPage-query_group-query_group_display",},
]}};
export default editor;